import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { SMSRecoveryReport } from '@core/models/sms-recovery-report.model';

@Injectable()
export class SMSRecoveryReportEntityService extends EntityCollectionServiceBase<SMSRecoveryReport> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('SMSRecoveryReport', serviceElementsFactory);
  }
}
